import { replacerWithoutPattern } from '../utils';

const STRING_REPLACER = 'OGYEXCEPTION';
const LINE_SEPARATOR = '---';
const VALUE_SEPARATOR = '###';

/**
 * Config unmarshaller parser to extract OMID Video verification trackers
 *
 * @param value
 * @param stringToKeep if set and found, the string will be replace by OGYEXCEPTION (will avoid to split string on --- force consent string)
 * @returns {any[]}
 */
export function parseOmidVideoTrackers(
  value: string = '',
  stringToKeep: string | undefined = undefined
) {
  const lines = replaceStringException(
    value,
    stringToKeep,
    STRING_REPLACER
  ).split(LINE_SEPARATOR);

  // consent string can contains '---', but we don't want to split this
  // so if a line doesn't contain any ###, we concat this line with the previous one
  for (let i = 0; i < lines.length; i++) {
    if (
      lines[i].indexOf(VALUE_SEPARATOR) === -1 &&
      typeof lines[i - 1] !== 'undefined'
    ) {
      lines[i - 1] += LINE_SEPARATOR + lines[i];
      delete lines[i];
    }
  }

  return lines
    .map(line => {
      const values = replaceStringException(
        line,
        STRING_REPLACER,
        stringToKeep
      ).split(VALUE_SEPARATOR);

      if (values.length !== 2 && values.length !== 3) {
        return;
      }

      if (!values[0] || !values[1]) {
        return;
      }

      return {
        vendorKey: values[0],
        resourceUrl: values[1],
        verificationParameters: values[2] || ''
      };
    })
    .filter(x => x);
}

export function replaceStringException(
  initialString: string,
  stringToReplace: string | undefined,
  replacer: string | undefined = ''
) {
  if (
    typeof stringToReplace !== 'undefined' &&
    stringToReplace != null &&
    stringToReplace.length > 0
  ) {
    return replacerWithoutPattern(
      initialString,
      new RegExp(`${stringToReplace}`, 'g'),
      replacer
    );
  }

  return initialString;
}
